import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const worldMentalHealthDayMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.WORLD_MENTAL_HEALTH_DAY,
  iFrameSrcUrl: '/wmhd',
  micrositeUrl: 'wmhd',
  title: {
    id: 'wmhd.title',
    defaultMessage: 'October 10 is World Mental Health Day',
    description: 'Microsite page title',
  },
  featureFlag: 'isWorldMentalHealthDayToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_ESSENTIALS,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/managing-anxiety-tools-and-support',
      },
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
  ],
  page: '202510 WMHD',
  trackUTMParams: {
    utm_campaign: 'WMHD2025',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'WMHD',
  },
  shouldSupportSpanish: false,
  shouldHideForInternational: false,
}
